import React, { useState } from "react";
import axios from "../utils/axios";

import Layout from "../components/Layout";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitted(false);

    try {
      await axios.post("/api/contact", formData);
      setSubmitted(true);
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      setError("❌ Something went wrong. Please try again.");
      console.error(err);
    }
  };

  return (
    <Layout>
      <div className="container py-5">
        <div className="text-center mb-5">
          <h1 className="mb-3">Let’s Connect</h1>
          <p className="lead">
            Whether you’re a CRP evaluating platforms, a admin with questions,
            or a job coach who needs a hand — we’re here to help.
          </p>
          <p className="fw-bold fs-5">
            📞 Call us at:{" "}
            <a href="tel:6812141453" className="text-decoration-none">
              681-363-0183
            </a>
          </p>
        </div>

        <div className="row g-5 align-items-start">
          {/* Left: Cards */}
          <div className="col-md-6">
            <h4 className="mb-4">📬 How Can We Help?</h4>
            <p>
              We’re committed to empowering service providers with reliable,
              flexible, and easy-to-use tools.
            </p>

            <div className="card shadow-sm p-4 mb-4">
              <h4 className="mb-3">📬 Common Reasons to Reach Out</h4>
              <div className="d-flex flex-column gap-3 fs-6">
                <div>
                  <strong>🛠️ Need help using WebVenly?</strong>
                  <p className="mb-0 text-muted">
                    Get technical support, walkthroughs, or help navigating
                    features.
                  </p>
                </div>
                <div>
                  <strong>🤝 Interested in a demo or onboarding?</strong>
                  <p className="mb-0 text-muted">
                    See how WebVenly can streamline your work — or start
                    training now.
                  </p>
                </div>
                <div>
                  <strong>📄 State compliance or feature questions?</strong>
                  <p className="mb-0 text-muted">
                    We partner with CRPs and funders to meet documentation
                    needs.
                  </p>
                </div>
                <div>
                  <strong>🔗 Exploring partnerships?</strong>
                  <p className="mb-0 text-muted">
                    We support collaboration with local and regional providers.
                  </p>
                </div>
                <div>
                  <strong>📣 General feedback or ideas?</strong>
                  <p className="mb-0 text-muted">
                    Your input helps shape the future of WebVenly.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Contact Form */}
          <div className="col-md-6">
            <div className="card shadow-sm p-4">
              <h4 className="mb-3">Contact Form</h4>

              {submitted && (
                <div className="alert alert-success">
                  ✅ Thanks for reaching out! Our team has received your message
                  and will respond as soon as possible.
                </div>
              )}
              {error && <div className="alert alert-danger">{error}</div>}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Subject</label>
                  <input
                    type="text"
                    name="subject"
                    className="form-control"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="e.g. Feature request, support, or partnership"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Message</label>
                  <textarea
                    name="message"
                    className="form-control"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell us how we can help..."
                    required
                  />
                </div>

                <div className="d-grid">
                  <button className="btn btn-primary" type="submit">
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Contact;
